import { useContext } from "react";
import { AxiosContext } from "../../contexts/AxiosContext";

// This is a hook that returns an axios instance with the auth0 token in the headers for authenticated requests to the backend API and add base URL to the axios instance
const useAxios = () => {
  const { instance } = useContext(AxiosContext);

  return instance;
};

export default useAxios;
